import React, { useContext } from "react";
import { Box, List, makeStyles } from "@material-ui/core";
import TestSeriesWhiteChipTableElement from "./TestSeriesWhiteChipTableElement";
import { TestSeriesContext } from "../../../../../../contexts/TestSeriesContext";
import BlackChipTooltip from "../../../../../../components/Chip/BlackChipTooltip";
import ParameterValue from "../../../../../../api/models/test-series/ParameterValue";
import formatSampleName from "../../../../../../api/services/common/formatSampleName";
import VerticalAlignedChip from "../../../../../../components/Chip/VerticalAlignedChip";

export interface TestSeriesTableElementProps {
  onPrimaryChipDelete: () => void;
  updateParentState: () => void;
  primaryChip: string;
  primaryChipSuffix?: string;
  primaryChipUnderline?: string;
  secondaryChips: any[];
  section: "substrate" | "material" | "testpiece" | "condition" | "measurement";
  flowType?: "TREATMENT" | "PREPARATION";
  enabled: boolean;
  validated: boolean;
  onChangeSuffix?: () => void;
  onRenamePrimary?: (newName: string) => void;
  parametersInAllTests?: ParameterValue[];
}

const useStyles = makeStyles({
  root: {
    width: "100%",
    maxWidth: 360,
  },
  tableElement: {
    paddingTop: "4px",
    paddingBottom: "4px",
    paddingLeft: "0px",
  },
  noPadding: {
    paddingTop: "0px",
    paddingBottom: "0px",
  },
  listAddButton: {
    color: "#757575",
    fontSize: "0.85rem",
    padding: 0,
    paddingTop: "10px",
    paddingBottom: "10px",
    size: "small",
    minWidth: "20px !important",
    maxWidth: "20px !important",
  },
});

const TestSeriesTableElement: React.FC<TestSeriesTableElementProps> = (props) => {
  const classes = useStyles(props);
  const {
    primaryChip,
    primaryChipSuffix,
    primaryChipUnderline,
    secondaryChips,
    onPrimaryChipDelete,
    updateParentState,
    section,
    flowType,
    enabled,
    validated,
    onChangeSuffix,
    onRenamePrimary,
    parametersInAllTests,
  } = props;
  const { showTextDialog } = useContext(TestSeriesContext);
  const sampleName = formatSampleName(primaryChip, primaryChipSuffix);

  return (
    <div className={classes.root}>
      <List className={classes.noPadding}>
        <Box className={classes.tableElement}>
          <BlackChipTooltip
            header={sampleName}
            subHeader={primaryChipUnderline}
            section={section}
            secondaryChips={secondaryChips}
          >
            <VerticalAlignedChip
              label={sampleName}
              onDelete={
                enabled
                  ? (): void => {
                      onPrimaryChipDelete();
                    }
                  : undefined
              }
              onClick={
                onRenamePrimary && enabled
                  ? (): void => {
                      showTextDialog("Flow Name", primaryChip, "Name")
                        .then(onRenamePrimary)
                        .catch(() => {
                          // do nothing
                        });
                    }
                  : onChangeSuffix && enabled
                  ? (): void => onChangeSuffix()
                  : undefined
              }
              color="primary"
            />
          </BlackChipTooltip>
        </Box>
        <TestSeriesWhiteChipTableElement
          section={section}
          flowType={flowType}
          enabled={enabled}
          validated={validated}
          chips={secondaryChips}
          updateParentState={updateParentState}
          parametersInAllTests={parametersInAllTests}
        />
      </List>
    </div>
  );
};

export default TestSeriesTableElement;
